import types from "./type";

const defaultState = {
  loading: false,
  selfie: null,
  ktp: null,
  ktp_selfie: null,
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.GET: {
      return {
        ...state,
        loading: true,
      };
    }
    case types.SET_SELFIE: {
      return {
        ...state,
        selfie: action.payload,
      };
    }
    case types.SET_KTP: {
      return {
        ...state,
        ktp: action.payload,
      };
    }
    case types.SET_SELFIE_KTP: {
      return {
        ...state,
        ktp_selfie: action.payload,
      };
    }
    case types.UPDATE: {
      return {
        ...state,
        loading: false,
      };
    }
    case types.DELETE: {
      return {
        ...state,
        loading: false,
      };
    }
    // DEFAULT
    default: {
      return state;
    }
  }
};

export default reducer;
